
import Vue, { PropType } from 'vue'

import { StoreState } from '@/store'

import { MenuItem } from '@/models'

import config from '@/config'

export default Vue.extend({
  name: 'MenuSP',
  props: {
    mItems: {
      type: Array as PropType<MenuItem[]>,
      default: () => []
    }
  },
  computed: {
    isShowMenu (): boolean {
      return (this.$store.state as StoreState).isShowMenu
    },
    twitterLink (): string {
      return config.external_link.twitter || ''
    },
    facebookLink (): string {
      return config.external_link.facebook || ''
    },
    blogLink (): string {
      return config.external_link.blog || ''
    },
    privacyPolicyLink (): string {
      return config.external_link.privacy_policy
    }
  },
  methods: {
    closeMenu (): void {
      this.$helper.enableScroll()
      this.$store.commit('SET_MENU', false)
    }
  }
})
